<div class="wrapper">
  <div class="price-box-wrapper">
    <div class="top-box">
      <h3 class="box-label">{{planData.displayName}}</h3>
    </div>
    <div class="rate-box-review-mode">
      <span class="price">${{planData.price.regularPrice}}/mo</span>
      <div class="price-description">
        <span class="price-details">plus $35 one-time activation fee</span>
      </div>
    </div>
    <div class="description"
      [innerHTML]="planData.shortDescription || 'In-vehicle internet access, powered by Verizon Nationwide.'">
    </div>
    <div class="info-links">
        <a href="https://www.verizon.com/support/important-plan-information" target="_blank">Important plan information</a>
        <a href="https://www.verizon.com/support/broadband-services" target="_blank">Important broadband information</a>
        <p> Need support? You can reach us at <a style="text-decoration: none;" href="tel:8009220204"  [innerHTML]="'800.922.0204' | textHighlight:'800.922.0204': 'blue-text'"></a></p>
    </div>
    <div *ngIf="planData.description" class="price-extra-details">
      {{planData.description}}
    </div>
  </div>
  <div class="top-box" *ngIf="billData">
    <h3 class="box-label">Here's how your bill will change</h3>
    <div class="date-box">
      <span class="title">Effective date</span>
      <span class="date">{{today}}</span>
    </div>
    <div class="bill-box">
      <div class="bill-box-item">
        <span class="title">Current bill</span>
        <span class="price">${{billData.currentBill}}/mo</span>
      </div>
      <img class="arrow-right">
      <div class="bill-box-item">
        <span class="title">New bill</span>
        <span class="price">${{billData.newBill}}/mo</span>
      </div>
    </div>
    <div class="description-box">
      <span>
        The cost of your next bill will be
        <span class="price">${{billData.nextBill}}*</span>
        due to one-time charge or credits.
      </span>
      <span>
        An estimate of your next bill and new account details will be emailed to you after the order is submitted.
      </span>
      <span>
        *Totals are estimated. Taxes, fees and surcharges will be itemized on your next bill.
      </span>
    </div>
    <div class="fees-description-box">
      <span class="title">
        Taxes, Surcharges and Fees
      </span>
      <span class="text">
        We use your service address for each wireless service line to determine how we bill taxes, 
        other governmental charges, and Verizon surcharges (which are Verizon's charges, not taxes). 
        As of September 1, 2023, for service other than 5G Home and LTE Home (which are not subject to these charges), 
        these charges can add between 12% and 47% to your standard monthly access and other charges, and may include a 
        Federal Universal Service Charge (29.2% of the interstate and international telecom charges; varies quarterly based on FCC rate), 
        Regulatory Charge ($0.16 cents per voice line, $0.02 cents per data-only line) and Administrative and 
        Telco Recovery Charge ($3.30 per voice line, $1.40 per data-only line). 
        Taxes, other governmental charges, and Verizon surcharges are subject to change. 
        For more details on these charges, call 1-888-684-1888. 
      </span>
    </div>

  </div>

</div>